import React, { useEffect, useState } from "react";
import ViewDetailsTable from "../shared/table/ViewDetailsTable";
import LTLPriceDetailsModal from "../modals/LTLPriceDetailsModal";
import { Fields } from "../../pages/Order-management/CustomerOrder/CustomerOrder-types";

interface GetLTLQuotePropsType {
  setFields: (field: any) => void;
  orderType?: string;
  quoteData: any[];
  setIsQuote: (value: boolean) => void;
  fields: Fields;
  isLtlFinalmile: boolean;
  saveQuotation: (quoteId: string) => void;
  quoteSelectedId?: string;
  formData?: any;
  calledFrom?: any;
  setIsSelectedParent?: (data: any) => void;
}
interface SelectedData {
  hubName?: string;
  agentName?: string;
  operationHrsFrom?: string;
  operationHrsTo?: string;
  addressName?: string;
  distanceToDestination?: number;
  serviceName?: string;
  quotePrice?: string;
  carrierName?: string;
  scac?: string;
  price?: string;
  priceWithMarkUp?: string;
  id?: string;
  agentHubId?: string;
  allQuoteId?: string;
  quoteId?: string;
  priceWithFinalMile: string;
}
// Define the columns to be used in the ViewDetailsTable
const columns = [
  {
    key: "count",
    header: "S.",
    isSortable: false,
    className: "calculateIndex",
  },
  {
    key: "carrierName",
    header: "Carrier Name",
    isSortable: true,
    className: "dark",
  },
  // {
  //   key: "mode",
  //   header: "Service",
  //   isSortable: true,
  //   className: "dark",
  // },
  {
    key: "scac",
    header: "Carrier Code",
    isSortable: true,
    className: "dark",
  },
  {
    key: "transitTime",
    header: "Estimated LTL Transit Days",
    isSortable: true,
    className: "dark",
  },
  {
    key: "priceWithMarkUpString",
    header: "Quote Price",
    isSortable: true,
    className: "dark",
  },
];

const ltlFinalMilecolumns = [
  {
    key: "count",
    header: "S.",
    isSortable: false,
    className: "calculateIndex",
  },
  {
    key: "carrierName",
    header: "Carrier Name(LTL)",
    isSortable: true,
    className: "dark",
  },
  {
    key: "finalmileCarrierName",
    header: "Agent(Final Mile)",
    isSortable: true,
    className: "dark",
  },
  // {
  //   key: "mode",
  //   header: "Service",
  //   isSortable: true,
  //   className: "dark",
  // },
  {
    key: "scac",
    header: "Carrier Code",
    isSortable: true,
    className: "dark",
  },
  {
    key: "transitTime",
    header: "Estimated LTL Transit Days",
    isSortable: true,
    className: "dark",
  },
  {
    key: "priceWithMarkUpString",
    header: "Quote Price",
    isSortable: true,
    className: "dark",
  },
  {
    key: "quoteFrom",
    header: "Quote From",
    isSortable: true,
    hide: true,
    className: "dark",
  },
  {
    key: "displayQuoteFrom",
    header: "Quote From",
    isSortable: true,
    className: "dark",
  },
];

interface ViewDetailsRowDataType {
  serial: number;
  serviceName: string;
  carrierName: string;
  description: string;
  serviceLevel: string;
  quotePrice: string;
  agentName: string;
  price: string;
  markup: number;
  priceWithMarkUp: string;
  fuelSurcharge: string;
  isProvidence?: boolean;
}

/**
 * GetQuote Component
 *
 * This component displays a list of quotes and allows the user to view details of a selected quote,
 * as well as to select a quote, which populates form fields with relevant data.
 *
 * @param setFields - Function to update form fields with selected quote data
 * @param quoteData - The array of quotes to display
 * @param setIsQuote - Function to update the state indicating whether a quote has been selected
 */
const GetLTLQuote: React.FC<GetLTLQuotePropsType> = ({
  orderType,
  setFields,
  quoteData,
  setIsQuote,
  fields,
  isLtlFinalmile,
  saveQuotation,
  quoteSelectedId,
  formData,
  calledFrom,
  setIsSelectedParent
}) => {
  const [viewPriceDetailsModal, setViewPriceDetailsModal] =
    useState<boolean>(false);
  const [viewDetailRowData, setViewDetailRowData] =
    useState<ViewDetailsRowDataType>();
  const [isSelected, setIsSelected] = useState<boolean>(false);
  const [selectedData, setSelectedData] = useState<SelectedData | null>(null);
  const [expandedSection, setExpandedSection] = useState<number | null>(null);

  /**
   * Handles the action of viewing details of a specific row in the table.
   * @param rowData - The data of the row to view in detail.
   */
  const handleViewDetails = (rowData: any) => {
    setViewDetailRowData(rowData);
    setViewPriceDetailsModal(true);
  };
  useEffect(() => {
    if (calledFrom !== "quickQuote") setIsSelected(false);
    setIsSelectedParent && setIsSelectedParent(false);
  }, [quoteData]);
  /**
   * Handles the action of selecting a specific quote.
   * Populates form fields with the data from the selected quote.
   * @param rowData - The data of the selected quote.
   */

  const handleSelect = (rowData: any) => {

    setSelectedData(rowData);
    // const data = rowData?.address;
    setIsSelected(true);
    setIsSelectedParent && setIsSelectedParent(true);
    setFields((prev: any) => ({
      ...prev,
      CarrierName: rowData.carrierName,
      serviceCost: rowData.price,
      scac: rowData.scac,
      distance: rowData.miles,
      offerId: rowData.offerId,
      costDetails: additionalCharges(rowData),
      markup: rowData.markup,
      productTransactionId: rowData.productTransactionId,
      customerMarkupType: rowData.customerMarkupType,
      plProvider: "",
      courierPro1: "",
      courierPro2: "",
      selectedQuoteId: rowData?.selectedQuoteId,
      parentQuoteId: rowData?.parentQuoteId,
      finalmile_quote_id: rowData?.finalMileData?.service?.quoteId || rowData?.selectedQuoteId,
      allQuoteId: rowData?.allQuoteId || rowData?.selectedQuoteId,
      quoteFrom: rowData?.quoteFrom,
      displayQuoteFrom: rowData?.displayQuoteFrom,
      banyanType: rowData?.banyanType,
      loadId: rowData?.loadId,
      internalLTL: rowData?.internalLTL,
      isProvidence: rowData?.isProvidence,
      finalMileSource: rowData?.finalMileData?.quoteFrom ?? rowData?.finalMileSource,
      source: rowData?.source,
      quoteDetailId: rowData?.quoteDetailId || "",
      quoteId: rowData?.quoteId || "",
      orderFor: rowData?.orderFor,
      carrierQuoteId: rowData?.carrierQuoteId,
      rateRequestLocator: rowData?.rateRequestLocator,
    }));
    formData = {
      ...formData,
      agentHubId: rowData?.agentHubId,
      selectedServiceId: rowData?.id,
      selectedQuoteId: rowData?.quoteId,
      allQuoteId: rowData?.allQuoteId,
      internalLTL: rowData?.internalLTL
    }

    setIsQuote(true);
  };
  const additionalCharges = (rowData: any): any[] => {
    const result = mapCharges(rowData?.additionalCharges);
    // if (rowData.markup) {
    //   result.push({ name: "Markup", amount: rowData.markup });
    // }
    return result;
  };
  const mapCharges = (charges: any[]): any[] => {
    return charges?.map((item) => ({
      name: item?.customerDescription,
      amount: item?.customerPrice?.value,
    }));
  };

  const handleFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFields((prevData: any) => ({ ...prevData, [name]: value }));
  };

  return (
    <>
      <div className="formRow">
        {isSelected && (
          <div>
            <div className="getQuoteBox">
              <p className="para">
                {/* Hub: Hub Name C/O Agent Name, City, State, Zipcode, Country, Hours of operation, Mile */}
                {`Carrier: ${selectedData?.carrierName}(${selectedData?.scac}) `}
              </p>
              <h3 className="title title--h3">
                Quote Price: $
                {/* {selectedData?.price */}
                {parseFloat(
                  orderType === "LTL"
                    ? selectedData?.priceWithMarkUp || selectedData?.price || "0.0"
                    : selectedData?.priceWithFinalMile !== "0" ? String(selectedData?.priceWithFinalMile) : selectedData?.price ?? "0.0"
                ).toFixed(2) || 0.0}
              </h3>
            </div>
            <>
              <section className="form__section">
                <h3 className="form__section__title">LTL Carrier Details</h3>
                <div className="formRow formRow__2">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="MidStopPhoneNumber"
                        className="form__label"
                      >
                        Carrier Name
                      </label>
                      <input
                        type="text"
                        id="MidStopZipcode"
                        name="MidStopZipcode"
                        className="form__input form__input--sm form__input--disabled"
                        placeholder="Carrier Name"
                        value={selectedData?.carrierName}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="MidStopPhoneNumber"
                        className="form__label"
                      >
                        Carrier Code
                      </label>
                      <input
                        type="text"
                        id="MidStopZipcode"
                        name="MidStopZipcode"
                        className="form__input form__input--sm form__input--disabled"
                        placeholder="Carrier Code"
                        value={selectedData?.scac}
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>
                <div className="formRow formRow__2">
                  <div className="formCol">
                    <div className="form__Field">
                      <label htmlFor="MidStopZipcode" className="form__label">
                        Origin City
                      </label>
                      <input
                        type="text"
                        id="MidStopZipcode"
                        name="MidStopZipcode"
                        className="form__input form__input--sm form__input--disabled"
                        placeholder="Origin City"
                        value={""}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="MidStopPhoneNumber"
                        className="form__label"
                      >
                        Service Cost
                      </label>
                      <input
                        type="text"
                        id="MidStopZipcode"
                        name="MidStopZipcode"
                        className="form__input form__input--sm form__input--disabled"
                        placeholder="Service Cost"
                        value={
                          orderType === "LTL"
                            ? `$${selectedData?.priceWithMarkUp}`
                            : `$${selectedData?.priceWithFinalMile}`
                        }
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>
                <div className="formRow formRow__2">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="MidStopPhoneNumber"
                        className="form__label"
                      >
                        3PL Provider
                      </label>
                      <input
                        type="text"
                        id="plProvider"
                        name="plProvider"
                        className="form__input form__input--sm"
                        placeholder="3PL Provider"
                        value={fields.plProvider}
                        onChange={handleFieldChange}
                      />
                    </div>
                  </div>
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="MidStopPhoneNumber"
                        className="form__label"
                      >
                        Courier Pro No.
                      </label>
                      <input
                        type="text"
                        id="courierPro1"
                        name="courierPro1"
                        className="form__input form__input--sm"
                        placeholder="Courier Pro No."
                        value={fields.courierPro1}
                        onChange={handleFieldChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="formRow formRow__2 mb_0">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="MidStopPhoneNumber"
                        className="form__label"
                      >
                        BOL No.
                      </label>
                      <input
                        type="text"
                        id="courierPro2"
                        name="courierPro2"
                        className="form__input form__input--sm form__input--disabled"
                        placeholder="BOL No."
                        value={""}
                        // onChange={handleFieldChange}
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>
              </section>
            </>
          </div>
        )}
        {!isSelected && (
          <div className="tableWrap p_0 mt_0">
            {quoteData.length ?
              <h3 className="mb_8 title title--h6 form__section__title form__section__title--flex">
                Service: {quoteData?.[0]?.mode}
                <div className="btn__group mb_0">
                  {quoteSelectedId ? "" :
                    <button
                      className="btn btn__white"
                      onClick={() => saveQuotation && saveQuotation("fbsf")}
                    >
                      Save Quote
                    </button>
                  }
                </div>
              </h3> : ""}
            <ViewDetailsTable
              columns={isLtlFinalmile ? ltlFinalMilecolumns : columns}
              data={quoteData}
              handleSelect={handleSelect}
              handleViewDetails={handleViewDetails}
              className={isLtlFinalmile ? "table--OrderLTLFinalMile" : "orderTable"}
              quoteSelectedId={quoteSelectedId}
              callingFrom={calledFrom}
              formData={formData}
              isSelected={isSelected}
              setIsSelected={setIsSelected}
              isLtlFm={isLtlFinalmile}
              setIsSelectedParent={setIsSelectedParent}
            // setLoading={setLoading}
            // onActiveConfig={tableConfig.active}
            // activeIcon={true}
            // getApiData={getAgentHubServiceZip}
            />
          </div>
        )}
      </div>
      {viewPriceDetailsModal && (
        <LTLPriceDetailsModal
          setConfirmModal={setViewPriceDetailsModal}
          rowData={viewDetailRowData}
        />
      )}
    </>
  );
};

export default GetLTLQuote;
